import React from 'react';
import { getColumnLabelsForTm } from '../utils/languages';

function TmLanguageSelector({
  selectedTmId,
  availableTMs = [],
  onTmChange,
  disabled = false,
  idPrefix = 'tm',
}) {
  const selectedTm = availableTMs.find((t) => t.tm_id === selectedTmId) || {};
  const labels = getColumnLabelsForTm(selectedTm);
  const tmSelectDisabled = disabled || availableTMs.length <= 1;

  return (
    <div className="form-row">
      <div className="form-group">
        <label className="form-label" htmlFor={`${idPrefix}-translationMemory`}>
          Translation Memory
        </label>
        <select
          id={`${idPrefix}-translationMemory`}
          className="form-select"
          value={selectedTmId}
          onChange={(e) => onTmChange && onTmChange(e.target.value)}
          disabled={tmSelectDisabled}
        >
          {availableTMs.map((tm) => (
            <option key={tm.tm_id} value={tm.tm_id}>{tm.label}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor={`${idPrefix}-sourceLanguage`}>
          Source Language
        </label>
        <select
          id={`${idPrefix}-sourceLanguage`}
          className="form-select"
          value={labels.sourceCode}
          disabled
        >
          <option value={labels.sourceCode}>{labels.source} ({labels.sourceCode})</option>
        </select>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor={`${idPrefix}-targetLanguage`}>
          Target Language
        </label>
        <select
          id={`${idPrefix}-targetLanguage`}
          className="form-select"
          value={labels.targetCode}
          disabled
        >
          <option value={labels.targetCode}>{labels.target} ({labels.targetCode})</option>
        </select>
      </div>
    </div>
  );
}

export default TmLanguageSelector;
